import styled from 'styled-components';
import { themeSize } from '../../../theme/getters';
import { ExperiencesList } from '../experiencesList';
import { Page as PageComponent } from '../../../shared/components/page';

export const Page = styled(PageComponent)`
  margin-bottom: ${({ isLoading }) => (isLoading ? 0 : 88)}px;
`;

export const Container = styled.div`
  padding-top: ${themeSize('header')}px;
`;

export const SimilarExperiences = styled(ExperiencesList)`
  width: 100%;
  padding: 0 ${themeSize('contentPadding')}px;
`;
